import React from "react";
import Pic from "../assets/books.jpg";
import PeoplePic from "../assets/IMG_0540.JPG";
import Pic2 from "../assets/IMG_0559.JPG";
import KnoxPic from "../assets/knox.jpg";
import BlogPic1 from "../assets/court.jpg";
import BlogPic2 from "../assets/image22.jpg";
import BlogPic3 from "../assets/stock.jpg";
import Pic3 from "../assets/IMG_0560.JPG";
import { Link } from "react-router-dom";
import { ContactBlurb, GMap } from "./Contact";
import {
  theme,
  Page,
  ImageBox,
  Blurb,
  ContactForm,
  BlogCard,
  Box,
  Heading,
  Caption,
  HeroBlurb,
  Text,
  Section,
  Image,
  Checkbox,
  Button
} from "../theme";

const Home = props => {
  return (
    <Page>
      <ImageBox useFilter="true" blend="soft-light" width={1} bgImage={Pic}>
        <HeroBlurb
          heading="Egerton McAfee"
          image={PeoplePic}
          color="secondaryLight"
          text="EGERTON MCAFEE ARMISTEAD & DAVIS P.C."
        />
      </ImageBox>
      <Section>
        <Box
          width={[2 / 3]}
          display="flex"
          py={3}
          justifyContent="center"
          alignItems="center"
        >
          <Blurb
            heading="About"
            subtitle="Learn More About Our Firm."
            image={PeoplePic}
            path="/about"
            text="Like any long-standing institution, the Knoxville law firm of Egerton, McAfee, Armistead & Davis has a robust heritage..."
          />
        </Box>

        <Box width={1 / 3}>
          <Box
            zIndex="2"
            bg="primary"
            mixBlendMode="color"
            width={1}
            height="100%"
            position="absolute"
          />
          <Image
            filter=" brightness(.68) contrast(2)  "
            src={KnoxPic}
            width={1}
            height="100%"
          />
        </Box>
      </Section>
      <Section bg="secondaryLight">
        <ImageBox
          useFilter="true"
          blend="overlay"
          width={[1 / 3]}
          bgImage={PeoplePic}
        />
        <Box
          width={[2 / 3]}
          py={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Blurb
            heading="People"
            image={PeoplePic}
            buttonText="Meet The Team"
            path="/people"
            text="The attorneys at Egerton McAfee are the firm’s greatest asset. They offer a wealth of expertise from their collective practical experience, yet always look for ways to innovate, ensuring their clients receive the most effective representation possible."
          />
        </Box>
      </Section>

      <Section id="practices">
        <Box
          width={[2 / 3]}
          py={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Blurb
            image={Pic2}
            heading="Practices"
            path="/practices"
            buttonText="View Practices"
            text="Egerton, McAfee offers an extensive range of legal services to national, regional and local clients. Experienced lawyers can be drawn from any of our practice groups to provide on-point solutions to the many facets of complex transactions and disputes."
          />
        </Box>
        <ImageBox
          useFilter="true"
          bg="primary"
          blend="color"
          width={[1 / 3]}
          bgImage={Pic3}
        />
      </Section>

      <Section bg="secondaryLight" py={3}>
        <Heading fontSize={4} width={1} textAlign="center" py={4}>
          Our Blogs
        </Heading>
        <Box
          width={1}
          maxWidth="80%"
          mb={4}
          display="flex"
          justifyContent="space-around"
          flexWrap={["wrap", null, null, "nowrap"]}
        >
          <BlogCard
            title="Death & Taxes"
            description="Tax Law, Estate Planning, and more..."
            image={BlogPic1}
          />
          <BlogCard
            title="LLC Life"
            description="Legal Advice for Your LLC"
            image={BlogPic2}
          />
          <BlogCard
            title="Finances & You"
            description="All Things Finance Law"
            image={BlogPic3}
          />
        </Box>
      </Section>

      <Section width={1} display="flex" alignItems="center" bg="white">
        <Box display={["none", "block"]} width={[1 / 2]}>
          <ContactBlurb width={1} />
          <ContactForm display={["none", "block"]} />
        </Box>
        <GMap width="50%" />
      </Section>
    </Page>
  );
};
export default Home;
